<template>
  <div class="choose-box" ref="selectRoleInfo">
    <p class="switch-way">
      <span
        class="switch-way-content j-click-logout-uid"
        @click="handleSwitchWay"
      >
        <span class="switch-way-content-ico"></span>
        {{ isLogin ? letter.logout : letter.storeSwitchWay }}
      </span>
    </p>
    <div class="uid-input-row">
      <input-comp
        :value="uid"
        :placeholder="letter.storeInputId"
        @blur="updateUid"
        @focus="initViewport"
        :disable="isLogin"
        pointClass="j-click-input-uid"
        class="uid-input j-click-input-uid"
      ></input-comp>
      <a
        class="uid-ask j-click-uid-guide-tip"
        v-if="!isLogin"
        @click="showGuidePopup"
      ></a>
      <div
        class="uid-search-btn j-click-search-uid"
        v-if="!isLogin"
        @click="doUidLogin"
      >
        {{ letter.storeSearch }}
      </div>
      <div class="uid-succ-ico" v-if="isLogin"></div>
    </div>
    <role-select v-if="isLogin"></role-select>
    <uid-guide-popup
      v-if="isShowGuidePopup"
      @hidePopup="isShowGuidePopup = false"
    ></uid-guide-popup>
    <beauty-uid-guide-popup
      v-bind:visible.sync="visibleBeautyGuide"
    ></beauty-uid-guide-popup>

    <div class="login-safe-check" v-if="isShowSafe">
      <template v-if="!isChecked">
        <div class="login-safe-spinning"></div>
        <span class="login-safe__text">
          {{ letter.safeChecking }}
        </span>
      </template>
      <template v-else>
        <div class="login-safe-success"></div>
        <span class="login-safe__text">
          {{ letter.safeChecked }}
        </span>
      </template>

    </div>
  </div>
</template>

<script>
import UidGuidePopup from '@components/officialStore/login/UidGuidePopup.vue'
import BeautyUidGuidePopup from '@components/officialStore/login/BeautyUidGuidePopup.vue'
import RoleSelect from '@components/officialStore/login/RoleSelect.vue'
import login from '@mixins/officialStore/login'
import gameInfoConfig from "@configs/officialStore/globalGameInfoConfig";
export default {
  mixins: [login],
  data() {
    return {
      isShowGuidePopup: false,
      visibleBeautyGuide: false,
      isChecked: false
    }
  },
  mounted() {
    let _self = this
    window.addEventListener('scroll', function () {
      if (!_self.gameId) return
      const top =
        _self.$refs.selectRoleInfo &&
        _self.$refs.selectRoleInfo.getBoundingClientRect() &&
        _self.$refs.selectRoleInfo.getBoundingClientRect().top
      _self.$emit('updateShowTopRole', top < -400)
    });

    // 定时随机2-5秒后显示安全检测成功
    setTimeout(() => {
      this.isChecked = true;
    }, (Math.random() * 3000) + 2000);
  },
  methods: {
    showGuidePopup() {
      if (this.gameId == 2) {
        this.visibleBeautyGuide = true
      } else {
        this.isShowGuidePopup = true
      }
    }
  },
  computed: {
    isShowSafe() {
      return !!gameInfoConfig[this.gameId]?.isShowSafe;
    }
  },
  components: {
    UidGuidePopup,
    RoleSelect,
    BeautyUidGuidePopup
  }
}
</script>

<style scoped lang="scss">
@import '@assets/scss/officialStore/officialStore.scss';
.choose-box {
  margin: 0 auto;
  background-size: cover;
  @psetbg ('choose-box.png');
}
.switch-way {
  margin-bottom: 45px;
  text-align: left;
  font-size: 30px;
  color: #f0f0f0;
  &-content {
    display: inline-block;
    margin-top: 66px;
    padding-left: 36px;
    cursor: pointer;
    text-align: left;
    font-size: 30px;
    color: #f0f0f0;
  }
  &-content-ico {
    display: inline-block;
    top: 123px;
    margin-right: 15px;
    background-size: cover;
    cursor: pointer;
    @psetbg ('return.png');
  }
}
.uid-input-row {
  display: flex;
  position: relative;
  align-items: center;
  box-sizing: border-box;
  margin: 0 auto 15px;
  width: 614px;
  height: 82px;
  font-size: 24px;
  color: #f0f0f0;
  .uid-input {
    box-sizing: border-box;
    margin: 0;
    background-size: cover;
    font-size: 24px;
    color: #f0f0f0;
    @psetbg ('uid-input-bg.png');
    ::v-deep .ocean-ui-form-input {
      padding: 0 38px;
      border: none;
      width: inherit;
      height: inherit;
      background: transparent;
      font-size: inherit;
      color: #fff;
    }
  }
  .uid-search-btn {
    margin-left: 14px;
    background-size: cover;
    line-height: 82px;
    text-align: center;
    font-size: 24px;
    color: #f0f0f0;
    @psetbg ('uid-search-btn.png');
  }
  .uid-ask {
    display: inline-block;
    position: absolute;
    right: 225px;
    top: 50%;
    background-size: cover;
    cursor: pointer;
    transform: translateY(-50%);
    @psetbg ('uid-ask-ico.png');
  }
  .uid-succ-ico {
    margin-left: 17px;
    background-size: cover;
    cursor: pointer;
    @psetbg ('uid-succ-ico.png');
  }
}

.login-safe-check {
  font-size: 22px;
  color: #ffea00;
  width: 542px;
  height: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  margin: auto;
  background: rgba(0,0,0,.8);
  border-radius: 10px;

  .login-safe-spinning {
    width: 27px;
    height: 26px;
    background-size: cover;
    animation: rotate 1s linear infinite;
    @psetbg ('login-safe-spinning.png')
  }

  .login-safe-success {
    width: 22px;
    height: 26px;
    background-size: cover;
    @psetbg ('login-safe-success.png')
  }
}
@media screen and (orientation: landscape) {
  .choose-box {
    // 这里
    position: relative;
    @psetbg ('choose-box-hen.png');
  }
  .back-select-login {
    left: 296px;
  }

  .login-safe-check {
    font-size: 18px;
  }
}
</style>
